import { render } from "./EventCard.vue?vue&type=template&id=a5489016&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=a5489016&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5489016"

export default script